/** @format */

// ひらがな -> カタカナ
const ToKatakana = (str) =>
  str.replace(/[\u3041-\u3096]/g, (c) =>
    String.fromCharCode(c.charCodeAt(0) + 0x60)
  );

/**
 * マスタデータ処理
 */
class LicenseMaster {
  static search(master, rankMaster, text) {
    const findName = text.toUpperCase();
    const findKana = ToKatakana(text);
    let list = [];
    let groups = [];
    for (const group of master) {
      const part = group.list.reduce((a, c) => {
        if (c.jname.toUpperCase().match(findName)) {
          a.push({
            id: c.license_id,
            name: c.jname,
            match: c.jname,
            type: c.type,
            ranks: rankMaster[c.license_id],
          });
        } else if (c.kana.match(findKana)) {
          a.push({
            id: c.license_id,
            name: c.jname,
            match: c.kana,
            type: c.type,
            ranks: rankMaster[c.license_id],
          });
        }
        return a;
      }, []);
      if (part.length > 0) {
        groups.push({ name: group.jname, list: part });
        list = list.concat(part.map((e) => e.match));
      }
    }
    return { groups, list };
  }
}

/**
 * 登録用データ管理
 */
class Licenses {
  constructor(list) {
    this.data = list.reduce((a, license) => {
      a[license.license_master_id] = {
        id: license.license_master_id,
        rank_id: license.license_rank_master_id,
        memo: license.memo,
        checked: true,
      };
      return a;
    }, {});
    this.otherId = 699;
  }

  update({ id, rank_id, memo, checked }) {
    if (typeof id === "undefined") {
      return;
    }
    if (typeof this.data[id] === "undefined") {
      this.data[id] = { id, rank_id: 0, memo: "", checked: true };
    }
    if (typeof rank_id !== "undefined") {
      this.data[id].rank_id = rank_id;
    }
    if (typeof memo !== "undefined") {
      this.data[id].memo = memo;
    }
    if (typeof checked !== "undefined") {
      this.data[id].checked = checked;
    }
  }

  isChecked(id) {
    return this.data[id] ? this.data[id].checked : false;
  }

  hasChecked() {
    return !!Object.values(this.data).find((e) => e.checked);
  }


  getRankId(id) {
    return this.data[id] ? this.data[id].rank_id : 0;
  }

  getMemo(id) {
    return this.data[id] ? this.data[id].memo : "";
  }

  getCheckedGroup(master) {
    let ids = [];
    const func = (category) => {
      for (const license of category.list) {
        const e = this.data[license.id];
        if (e && e.checked) {
          return true;
        }
      }
      return false;
    };
    for (const category of master) {
      if (func(category)) {
        ids.push(category.id);
      }
    }
    return ids;
  }

  getPostData(master) {
    let license_items = [];
    let license_item_ranks = {};
    let license_item_memos = {};
    let errors = {};
    for (const category of master) {
      for (const license of category.list) {
        const e = this.data[license.license_id];
        if (e && e.checked) {
          license_items.push(e.id);
          if (license.type == "select") {
            license_item_ranks[`license_item_rank_${e.id}`] = e.rank_id;
            if (e.rank_id == 0) {
              // errors[e.id] = "選択してください。";
            }
          }
          if (license.type == "score") {
            license_item_memos[`license_item_memo_${e.id}`] = e.memo;
            if (!e.memo) {
              // errors[e.id] = "入力してください。";
            }
          }
        }
      }
    }
    // その他
    if (this.data[this.otherId] && this.data[this.otherId].checked) {
      license_items.push(this.otherId);
      license_item_memos[`license_item_memo_${this.otherId}`] = this.data[
        this.otherId
      ].memo;
    }
    if (Object.values(errors).length > 0) {
      throw {
        message: "failed",
        data: { text: "入力に問題があります", errors },
      };
    }

    return { license_items, license_item_ranks, license_item_memos };
  }
}

export { LicenseMaster, Licenses };
